<template>
  <v-dialog max-width="1000px" v-model="dialog">
    <v-card>
      <v-card-title class="headline">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="pr-5" large v-on="on" @click="crearPDF()"
              >cloud_download</v-icon
            >
          </template>
          <span>Descargar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="pr-5" large v-on="on" @click="sendEmail()"
              >email</v-icon
            >
          </template>
          <span>Enviar por Email</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="pr-5" large v-on="on" @click="sendWhatsApp()"
              >send</v-icon
            >
          </template>
          <span>Imprimir</span>
        </v-tooltip>
      </v-card-title>
      <v-container id="contenedor">
        <v-card-text v-for="i in imprimir" :key="i.id_reserva">
          <div
            class="factura"
            style="padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;"
          >
            <header>
              <div id="datos" style="float: center;
  margin-top: 0%;
  margin-left: 2%;
  padding-top: 20px;
  margin-right: 2%;">
                <div id="logo" style="text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;">
                  <img src="../../assets/logoRent.png" id="imagen" style="width: 200px;
  height: 100px;"/>
                </div>
                <p id="encabezado" style="text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;">
                  <br />Telefono: +34-630-262-143 <br />Email:
                  reservas@librarentacar.com
                </p>
              </div>
            </header>
            <br />
            <section>
              <div>
                <v-row>
                  <v-col>
                    <strong>Id. Reserva {{ i.id_reserva }}</strong>
                    <br />
                    <strong>Sr(a). {{ i.nombre }} {{ i.apellido }}</strong>
                    <br />
                    <strong>Teléfono: {{ i.telefono }}</strong>
                    <br />
                    <strong>Email: {{ i.email }}</strong>
                    <br />
                  </v-col>
                  <v-col>
                    <strong>Entrega: {{ i.fecha_recogida }}</strong>
                    <br />
                    <strong>Lugar Entrega: {{ i.lugar_recogida }}</strong>
                    <br />
                    <strong>Hora Entrega: {{ i.hora_recogida }}</strong>
                    <br />
                  </v-col>
                  <v-col>
                    <strong>Devolución: {{ i.fecha_entrega }}</strong>
                    <br />
                    <strong>Lugar Devolución: {{ i.lugar_entrega }}</strong>
                    <br />
                    <strong>Hora Devolución: {{ i.hora_recogida }}</strong>
                    <br />
                  </v-col>
                </v-row>
              </div>
            </section>
            <br />
            <section>
              <div>
                <table id="facarticulo" style="width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;">
                  <thead>
                    <tr id="fa" style="color: #ffffff;
  font-size: 14px;">
                      <th>COCHE</th>
                      <th>MARCA</th>
                      <th>MODELO</th>
                      <th>OBSERVACIONES</th>
                      <th>GRUPO</th>
                      <th>{{ i.tipo_francdepos.toUpperCase() }}</th>
                      <th>TARIFA</th>
                      <th>TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="text-align: center;">{{ i.id_coche }}</td>
                      <td style="text-align: center;">{{ i.marca }}</td>
                      <td style="text-align: center;">{{ i.modelo }}</td>
                      <td style="text-align: center;">
                        {{ i.observaciones }}
                      </td>
                      <td style="text-align: center;">{{ i.grupo }}</td>
                      <td style="text-align: center;">
                        {{ i.valor_francdepos }}
                      </td>
                      <td style="text-align: center;">{{ i.tarifa }}</td>
                      <td style="text-align: center;">{{ i.total }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <br />
            <br />
            <footer>
              <div id="gracias">
                <p>
                  <b>Gracias por su preferencia!</b>
                </p>
                <p>Original cliente</p>
              </div>
            </footer>
            <hr id="hr" />
          </div>
          <div class="factura">
            <section>
              <div>
                <v-row>
                  <v-col>
                    <strong>Id. Reserva {{ i.id_reserva }}</strong>
                    <br />
                    <strong>Sr(a). {{ i.nombre }} {{ i.apellido }}</strong>
                    <br />
                    <strong>Teléfono: {{ i.telefono }}</strong>
                    <br />
                    <strong>Email: {{ i.email }}</strong>
                    <br />
                  </v-col>
                  <v-col>
                    <strong>Entrega: {{ i.fecha_recogida }}</strong>
                    <br />
                    <strong>Lugar Entrega: {{ i.lugar_recogida }}</strong>
                    <br />
                    <strong>Hora Entrega: {{ i.hora_recogida }}</strong>
                    <br />
                  </v-col>
                  <v-col>
                    <strong>Devolución: {{ i.fecha_entrega }}</strong>
                    <br />
                    <strong>Lugar Devolución: {{ i.lugar_entrega }}</strong>
                    <br />
                    <strong>Hora Devolución: {{ i.hora_recogida }}</strong>
                    <br />
                  </v-col>
                </v-row>
              </div>
            </section>
            <br />
            <section>
              <div>
                <table id="facarticulo">
                  <thead>
                    <tr id="fa">
                      <th>COCHE</th>
                      <th>MARCA</th>
                      <th>MODELO</th>
                      <th>OBSERVACIONES</th>
                      <th>GRUPO</th>
                      <th>{{ i.tipo_francdepos.toUpperCase() }}</th>
                      <th>TARIFA</th>
                      <th>TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="text-align: center;">{{ i.id_coche }}</td>
                      <td style="text-align: center;">{{ i.marca }}</td>
                      <td style="text-align: center;">{{ i.modelo }}</td>
                      <td style="text-align: center;">
                        {{ i.observaciones }}
                      </td>
                      <td style="text-align: center;">{{ i.grupo }}</td>
                      <td style="text-align: center;">
                        {{ i.valor_francdepos }}
                      </td>
                      <td style="text-align: center;">{{ i.tarifa }}</td>
                      <td style="text-align: center;">{{ i.total }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <br />
            <br />
            <footer>
              <div id="gracias">
                <p>
                  <b>Gracias por su preferencia!</b>
                </p>
                <p>Copia empresa</p>
              </div>
            </footer>
          </div>
        </v-card-text>
      </v-container>
      <v-card-actions>
        <v-btn @click="ocultarComprobante()" color="blue darken-1" text
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      detalles_existe: false,
    };
  },
  props: {
    imprimir: Array,
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  computed: {
    ...mapState("usuarioNamespace", ["token"]),
  },
  methods: {
    ocultarComprobante() {
      this.$emit("close");
    },
    crearPDF() {
      var quotes = document.getElementById("contenedor");
      html2canvas(quotes).then(function(canvas) {
        var imgData = canvas.toDataURL("image/png");
        var imgWidth = 210;
        var pageHeight = 295;

        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;

        var doc = new jsPDF("p", "mm", "a4");
        var position = 0;

        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        doc.save("ComprobanteReserva.pdf");
      });
    },
    sendEmail() {},
    toPrint() {
      this.$htmlToPaper("contenedor");
    },
    sendWhatsApp() {
      this.$htmlToPaper("contenedor", null, () => {
        if (sessionStorage.desktop) {
          let test = "Prueba mensaje";
          window.open(`https://api.whatsapp.com/send`);
        } else if (localStorage.mobile) {
          let test2 = "Prueba mensaje";
          window.open(`whatsapp://send?phone=Desde app ${test2}`);
        }
      });
    },
  },
};
</script>
<style>
#hr {
  color: #f8b500;
  height: 0px;
  border: 1px dashed;
}
#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#logo {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}
#imagen {
  width: 200px;
  height: 100px;
}

#fact {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

#datos {
  float: center;
  margin-top: 0%;
  margin-left: 2%;
  padding-top: 20px;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 40%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
}

#facarticulo thead {
  padding: 20px !important;
  background: #f4d03f;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}

#gracias {
  text-align: center;
}
</style>
